import React, { useState, useEffect, useCallback } from 'react';
import { connect } from 'react-redux';
import { Button, Container, Title, View } from '@common/components';
import { Row, Col, Layout } from 'antd';
import { Helmet } from 'react-helmet';
import { fetchOrganization } from '@common/resources/Organization/actions';
import {
	fetchVenues,
	fetchVenuesByOrganization,
	clearVenues,
} from '@resources/Venue/actions';
import { FormattedMessage, useIntl } from 'react-intl';
import { VenueItem } from '@fragments/items';
import CreateModal from './Create';
import UpdateModal from './Update';

const { Content } = Layout;

const Venue = (props) => {
	const {
		venues,
		fetchVenues,
		fetchVenuesByOrganization,
		clearVenues,
		organization,
		history,
	} = props;
	const intl = useIntl();
	const [create, setCreate] = useState(false);
	const [update, setUpdate] = useState(false);

	useEffect(() => {
		const func = async () => {
			await clearVenues();

			organization?._id
				? await fetchVenuesByOrganization(organization?._id)
				: await fetchVenues();
		};

		func();
	}, [fetchVenues, fetchVenuesByOrganization, clearVenues, organization]);

	const parseDataSource = useCallback(() => {
		return venues.map((venue) => {
			return {
				key: venue._id,
				...venue,
			};
		});
	}, [venues]);

	const handleClick = (venue) => {
		history.push(
			`/${venue.organization.alias}/venues/${venue._id}/details`
		);
	};

	return (
		<Content>
			<Helmet>
				<title>
					{intl.formatMessage({
						id: 'common.venue.management',
						defaultMessage: 'Venue Management',
					})}
				</title>
			</Helmet>
			<CreateModal
				{...props}
				module={module}
				visible={create}
				onCancel={() => setCreate(false)}
			/>

			<UpdateModal
				{...props}
				module={module}
				visible={update}
				onCancel={() => setUpdate(false)}
			/>
			<Container>
				<View>
					<Row
						type="flex"
						justify="center"
						align="middle"
						className="mt-5">
						<Col md={{ span: 12 }}>
							<Title>
								<FormattedMessage
									id="common.venues"
									defaultMessage="Venues"
								/>
							</Title>
						</Col>
						<Col md={{ span: 12 }} className="text-right">
							<Button
								type="primary"
								onClick={() => setCreate(true)}>
								<FormattedMessage
									id="common.new.venue"
									defaultMessage="New Venue"
								/>
							</Button>
						</Col>
					</Row>
					{parseDataSource() &&
						parseDataSource().map((venue, index) => (
							<VenueItem
								key={`venue-${index}`}
								venue={venue}
								onEdit={() => setUpdate(venue._id)}
								onClick={handleClick}
							/>
						))}
				</View>
			</Container>
		</Content>
	);
};

const mapStateToProps = ({
	venues,
	modules,
	cellGroup,
	event,
	facility,
	ministry,
	mission,
	organization,
	prayer,
	testimony,
	venue,
}) => {
	return {
		venues,
		modules,
		cellGroup,
		event,
		facility,
		ministry,
		mission,
		organization,
		prayer,
		testimony,
		venue,
	};
};

export default connect(mapStateToProps, {
	fetchOrganization,
	fetchVenues,
	fetchVenuesByOrganization,
	clearVenues,
})(Venue);
